import regExpValidator from './regExpValidator';

const emailRegExpValidator = (message: string = 'validators.email.format') =>
  regExpValidator(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/,
    message
  );

export default emailRegExpValidator;
